export default (axios) => ({
  getBreadcrumbs(query) {
    return axios.get(`/v1/api/breadcrumbs`, {
      params: {
        ...query
      }
    })
  },

  createAffiliateCookies(query) {
    return axios.get('/v1/api/affiliate', {
      params: {
        ...query
      }
    })
  },

  getGeoAutocomplete(body) {
    return axios.post('/v1/api/geo/autocomplete', body)
  },
  getGeocode(placeId) {
    return axios.get(`/v1/api/geo/geocode/resolve/${placeId}`)
  },

  getLanguages() {
    return axios.get('/v1/api/languages')
  },
  getCountry() {
    return axios.get('/v1/api/country')
  }
})
